export default __webpack_public_path__ + "static/media/incr_HS.a8242c55.PNG";